export const
	APP_SET_THEME = 'APP_SET_THEME',
	APP_SET_APP_SIZE = 'APP_SET_APP_SIZE',
	APP_COLLECTIONS_SEARCH_RESULTS_HIDE = 'APP_COLLECTIONS_SEARCH_RESULTS_HIDE',
	APP_TOGGLE_HIGHLIGHTS = 'APP_TOGGLE_HIGHLIGHTS',
	APP_SET_VISITED_SPACE = 'APP_SET_VISITED_SPACE'